import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

import AppsIntroSection from './AppsIntroSection'
import AppsOutroSection from './AppsOutroSection'
import QuickStartSection from './QuickStartSection'
import TemplateSection from './TemplateSection'
import Box from '@mui/material/Box'

import { isKeywordGraphApp } from '../appVariant'
import { useSnackbar } from '../components/Snackbar'

const ERROR_MESSAGES = {
    private_graph: ({ user, context }) => {
        const target = context
            ? `<strong>${user}/${context}</strong>`
            : `<strong>${user}</strong>'s private graphs`
        return `You don't have access to ${target}. The graph is private — ask the owner to make it public or share it with you.`
    },
}

export default function Apps(props) {
    const [searchParams, setSearchParams] = useSearchParams()
    const showSnackbar = useSnackbar(state => state.showSnackbar)

    React.useEffect(() => {
        const errorKey = searchParams.get('error')
        const buildMessage = errorKey && ERROR_MESSAGES[errorKey]
        if (!buildMessage) return

        showSnackbar(
            'warning',
            buildMessage({
                user: searchParams.get('user') || '',
                context: searchParams.get('context') || '',
            }),
            'top-right',
            8000
        )

        const next = new URLSearchParams(searchParams)
        next.delete('error')
        next.delete('user')
        next.delete('context')
        setSearchParams(next, { replace: true })
    }, [searchParams, setSearchParams, showSnackbar])

    return (
        <>
            <Box
                component="main"
                sx={{
                    backgroundColor: theme => theme.palette.background.default,
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                    marginLeft: 4,
                }}
            >
                <AppsIntroSection />
                <QuickStartSection />
                <TemplateSection />
                {!isKeywordGraphApp() && <AppsOutroSection />}
            </Box>
        </>
    )
}
